import {
  UPDATE_CHANNEL_WHATSAPP_STATUS,
  UPDATE_CHANNEL_VOICE_STATUS,
  RESET_CHANNEL,
  CONNECT_CHAT_VISOR,
  UPDATE_WHATSAPPS_ON_HOLD,
  SET_VOICE_ON_HOLD,
  UPDATE_CHAT_ON_HOLD,
  SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT,
} from '../../mutation-types';
import Channels from '../../../weon/models/Channels';
import Vue from 'vue';
import { getActiveJobsFromChannel } from '@/shared/utils/job-helpers';

const mutations = {
  [UPDATE_CHANNEL_WHATSAPP_STATUS](state, status) {
    const statusList = ['paused', 'scheduled_pause'];
    const { jobList } = this.state.jobs;
    const jobsChannel = getActiveJobsFromChannel('WhatsApp', jobList);
    const emptyWhatsAppJobList = jobsChannel.length < 1;

    if (statusList.includes(status) && !emptyWhatsAppJobList) {
      state.channels.whatsapp.status = 'scheduled_pause';
    } else {
      state.channels.whatsapp.status = status;
    }
  },

  [UPDATE_CHAT_ON_HOLD](state, onHold) {
    state.channels.chat.onHold = onHold;
  },

  [UPDATE_CHANNEL_VOICE_STATUS](state, status) {
    if (status.toLowerCase() == 'manual') {
      status = 'processing';
    }
    state.channels.voice.status = status;
  },

  [UPDATE_WHATSAPPS_ON_HOLD](state, whatsAppsOnHold) {
    Vue.set(state.channels.whatsapp, 'onHold', whatsAppsOnHold);
  },

  [SET_VOICE_ON_HOLD](state, onHold) {
    Vue.set(state.channels.voice, 'onHold', onHold);
  },

  [RESET_CHANNEL](state) {
    state.channels = new Channels();
  },

  [CONNECT_CHAT_VISOR](state) {
    state.chatVisor = true;
  },
  [SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT](state, latestStatus) {
    state.latestVoiceStatusBeforeDisconnect.status = latestStatus.status;
    state.latestVoiceStatusBeforeDisconnect.description =
      latestStatus.description;
  },
};

export default mutations;
